import urlConfig from "../config/urlConfig.js";

var authority = urlConfig.authority;
var erp = urlConfig.erp;
var pos = urlConfig.pos;

var devApi = {
  // 功能管理
  funManage: {
    // 系统管理树形结构列表
    devFunManageList: "/sysFunction/all/",
    // 系统管理树形显示
    devTreeShow: "/sysFunction/findAllFn/",
    // 显示全部按钮
    devBtnShow: "/sysBtn/all/",
    // 删除树形的数据
    devTreeDel: "/sysFunction/del/",
    // 功能禁用
    devDisEnableFunction: "authority/sysFunction/disEnableFunction/",
    // 功能启用
    devEnableFunction: "/sysFunction/enableFunction/",
    // 表单新增
    devAddForm: "/sysFunction/addFunction/",
    // 树形数据修改
    devTreeModify: "/sysFunction/modifyFunction/"
  },
  //按钮管理
  butManage: {
    //按钮列表
    devBtnList: "/sysBtn/showList/",
    //按钮删除
    devBtnDel: "/sysBtn/del/",
    //按钮添加
    devBtnButton: "/sysBtn/addButton/",
    //按钮修改
    devBtnModify: "/sysBtn/modifyButton/"
  }
};
export default devApi;



// WEBPACK FOOTER //
// ./src/api/devApi.js